// import React from "react";
// import "./NurseCareer.css";
// import InquiryForm from "../InquiryForm";

// const NurseAustraliaCareer = () => {
//   return (
//     <>
//       <div className="nurse-career-img">
//         <img
//           src="https://ihm.edu.au/wp-content/uploads/2022/10/MicrosoftTeams-image-68-scaled.jpg "
//           alt="img in australia"
//         />
//       </div>
//       <div className="nurse-career nurse-australia">
//         <header className="career-header">
//           <h1>Career as a Nurse in Australia</h1>
//           <p>
//             Nursing is one of the most respected and in-demand careers in
//             Australia. With a strong healthcare system, Australia provides
//             nurses with excellent career opportunities, competitive salaries,
//             and pathways for growth.
//           </p>
//         </header>

//         <section className="career-details">
//           <h2>Why Choose Nursing in Australia?</h2>
//           <ul>
//             <li>High demand for skilled nurses across all states</li>
//             <li>Attractive salary packages and allowances</li>
//             <li>Opportunities for specialization and advanced studies</li>
//             <li>Permanent residency pathways for international nurses</li>
//           </ul>
//         </section>

      

//         <div className="about ">
//             <span>NCLEX : The National Council Licensure Examination :</span>
//           <p>
//              It is a
//             standardized exam designed to assess the knowledge and skills of
//             individuals seeking certification as a nurse in the United States ,
//             Australia & Canada. There are two versions of the exam—one for
//             prospective RNs and one for future LPNs. Each exam is tailored to
//             assess the skills and knowledge necessary for that specific field.
//             The National Council Licensure Examination for Registered Nurses
//             (NCLEX-RN) is the test nursing graduates must pass to be licensed as
//             a Registered Nurse in above mentioned countries. It is offered by
//             the National Council of State Boards of Nursing (NCSBN). OSCE for
//             RN’s : Objective Structured Clinical Examination for Registered
//             Nurses.: OSCE, which stands for Objective Structured Clinical
//             Examination, is a performance-based assessment used in the medical
//             and healthcare fields to evaluate practical and clinical skills.
//             Candidates face multiple stations with simulated scenarios,
//             interacting with standardized patients and medical equipment to
//             demonstrate their clinical abilities, communication skills, and
//             problem-solving skills. This format allows examiners to objectively
//             assess candidates’ readiness for real-world practice, making it a
//             crucial evaluation tool in medical schools and healthcare training
//             programmes. It is necessary to pass this exam for students if they
//             want to make career in Australia.{" "}
//           </p>
//         </div>
//          {/* ── INQUIRY FORM ── */}
//         <div className="form-wrapper">
//           <InquiryForm title="Inquire About Physiotherapy in Germany" />
//         </div>
//       </div>
//     </>
//   );
// };

// export default NurseAustraliaCareer;

// import React from "react";
// import "./NurseCareer.css";
// import InquiryForm from "../InquiryForm";

// const NurseAustraliaCareer = () => {
//   return (
//     <>
//       {/* Small banner image */}
//     <div className="nurse-career-img">
//   <img
//     src="https://ihm.edu.au/wp-content/uploads/2022/10/MicrosoftTeams-image-68-scaled.jpg"
//     alt="Nursing in Australia"
//     style={{
//       width: "500px",         // ✅ small fixed width
//       height: "auto",        // ✅ height adjusts automatically, no cut
//       display: "block",
//       margin: "0 auto",      // center it
//       borderRadius: "8px",
//     }}
//   />
// </div>

//       <div className="nurse-career nurse-australia">
//         <header className="career-header">
//           <h1>Career as a Nurse in Australia</h1>
//           <p>
//             Nursing is one of the most respected and in-demand careers in
//             Australia. With a strong healthcare system, Australia provides
//             nurses with excellent career opportunities, competitive salaries,
//             and pathways for growth.
//           </p>
//         </header>

//         <section className="career-details">
//           <h2>Why Choose Nursing in Australia?</h2>
//           <ul>
//             <li>High demand for skilled nurses across all states</li>
//             <li>Attractive salary packages and allowances</li>
//             <li>Opportunities for specialization and advanced studies</li>
//             <li>Permanent residency pathways for international nurses</li>
//           </ul>
//         </section>

//         <div className="about">
//           <span>NCLEX : The National Council Licensure Examination :</span>
//           <p>
//             It is a standardized exam designed to assess the knowledge and
//             skills of individuals seeking certification as a nurse in the United
//             States, Australia & Canada. There are two versions of the
//             exam—one for prospective RNs and one for future LPNs. Each exam is
//             tailored to assess the skills and knowledge necessary for that
//             specific field. The National Council Licensure Examination for
//             Registered Nurses (NCLEX-RN) is the test nursing graduates must
//             pass to be licensed as a Registered Nurse in above mentioned
//             countries. It is offered by the National Council of State Boards of
//             Nursing (NCSBN). OSCE for RN's : Objective Structured Clinical
//             Examination for Registered Nurses.: OSCE, which stands for
//             Objective Structured Clinical Examination, is a performance-based
//             assessment used in the medical and healthcare fields to evaluate
//             practical and clinical skills. Candidates face multiple stations
//             with simulated scenarios, interacting with standardized patients and
//             medical equipment to demonstrate their clinical abilities,
//             communication skills, and problem-solving skills. This format allows
//             examiners to objectively assess candidates' readiness for real-world
//             practice, making it a crucial evaluation tool in medical schools and
//             healthcare training programmes. It is necessary to pass this exam
//             for students if they want to make career in Australia.
//           </p>
//         </div>

//         {/* ── INQUIRY FORM ── */}
//         <div className="form-wrapper">
//           <InquiryForm title="Inquire About Nursing in Australia" />
//         </div>
//       </div>
//     </>
//   );
// };

// export default NurseAustraliaCareer;
import React, { useEffect, useState } from "react";

const NurseAustraliaCareer = () => {
  const [isMobile, setIsMobile] = useState(() => (typeof window !== "undefined" ? window.innerWidth <= 768 : false));

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ fontFamily: "'Segoe UI', Arial, sans-serif", maxWidth: "1100px", margin: "0 auto", padding: isMobile ? "20px 14px" : "30px 20px" }}>

      {/* Top Two-Column: Image Left, Content Right */}
      <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: isMobile ? "16px" : "30px", alignItems: "flex-start", marginBottom: isMobile ? "24px" : "40px" }}>

        {/* Left - Image */}
        <div style={{ flex: isMobile ? "0 0 auto" : "0 0 400px", width: isMobile ? "100%" : "400px" }}>
          <img
            src="https://ihm.edu.au/wp-content/uploads/2022/10/MicrosoftTeams-image-68-scaled.jpg"
            alt="Nursing in Australia"
            style={{ width: "100%", height: isMobile ? "220px" : "320px", objectFit: "cover", borderRadius: "10px", display: "block" }}
          />
        </div>

        {/* Right - Main Intro Content */}
        <div style={{ flex: 1, width: "100%" }}>
          <h1 style={{ fontSize: "28px", color: "#1a3c5e", marginBottom: "15px" }}>Career as a Nurse in Australia</h1>
          <p style={{ fontSize: "15px", lineHeight: "1.7", color: "#444", marginBottom: "20px" }}>
            Nursing is one of the most respected and in-demand careers in Australia. With a strong healthcare system,
            Australia provides nurses with excellent career opportunities, competitive salaries, and pathways for growth.
          </p>

          <h2 style={{ fontSize: "18px", color: "#1a3c5e", marginBottom: "10px" }}>Why Choose Nursing in Australia?</h2>
          <ul style={{ paddingLeft: "20px", fontSize: "15px", lineHeight: "2", color: "#444" }}>
            <li>High demand for skilled nurses across all states</li>
            <li>Attractive salary packages and allowances</li>
            <li>Opportunities for specialization and advanced studies</li>
            <li>Permanent residency pathways for international nurses</li>
          </ul>
        </div>
      </div>

      {/* NCLEX Section - Full Width Below */}
      <div style={{ background: "#f5f8fc", borderRadius: "10px", padding: "25px 30px", marginBottom: "30px" }}>
        <p style={{ fontSize: "15px", fontWeight: "700", color: "#1a3c5e", marginBottom: "10px" }}>
          NCLEX : The National Council Licensure Examination
        </p>
        <p style={{ fontSize: "15px", lineHeight: "1.8", color: "#444" }}>
          It is a standardized exam designed to assess the knowledge and skills of individuals seeking certification
          as a nurse in the United States, Australia & Canada. There are two versions of the exam — one for prospective
          RNs and one for future LPNs. The NCLEX-RN is offered by the National Council of State Boards of Nursing (NCSBN).
          OSCE (Objective Structured Clinical Examination) for RNs is a performance-based assessment used to evaluate
          practical and clinical skills through simulated scenarios with standardized patients and medical equipment.
          It is necessary to pass this exam for students who want to make a career in Australia.
        </p>
      </div>

      {/* Inquiry Form */}
      <div style={{ background: "#f5f8fc", borderRadius: "10px", padding: isMobile ? "20px 16px" : "30px" }}>
        <h2 style={{ fontSize: "22px", color: "#1a3c5e", marginBottom: "20px" }}>Inquire About Nursing in Australia</h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px", maxWidth: "600px" }}>
          <div>
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#333", display: "block", marginBottom: "5px" }}>Name:</label>
            <input type="text" placeholder="Enter your name"
              style={{ width: "100%", padding: "10px 14px", fontSize: "15px", border: "1px solid #ccc", borderRadius: "6px", outline: "none" }} />
          </div>
          <div>
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#333", display: "block", marginBottom: "5px" }}>Email:</label>
            <input type="email" placeholder="Enter your email"
              style={{ width: "100%", padding: "10px 14px", fontSize: "15px", border: "1px solid #ccc", borderRadius: "6px", outline: "none" }} />
          </div>
          <div>
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#333", display: "block", marginBottom: "5px" }}>Message:</label>
            <textarea placeholder="Enter your message" rows={4}
              style={{ width: "100%", padding: "10px 14px", fontSize: "15px", border: "1px solid #ccc", borderRadius: "6px", outline: "none", resize: "vertical" }} />
          </div>
          <button type="button"
            style={{ width: isMobile ? "100%" : "160px", padding: "11px", background: "#1a3c5e", color: "#fff", fontSize: "15px", fontWeight: "600", border: "none", borderRadius: "6px", cursor: "pointer" }}>
            Submit
          </button>
        </div>
      </div>
          <div className="back-home-wrapper">
  <button className="back-home-btn" onClick={() => window.location.href = "/"}>
    ← Go Back to Home
  </button>
</div>
    </div>
  );
};

export default NurseAustraliaCareer;